/**
 * Current hockey season — computed dynamically from today's date so it never
 * needs manual updating each year.
 *
 * A season is named by the two calendar years it spans (fall → spring). We flip
 * to the upcoming season in July: from July 1 onward the "current season" is
 * thisYear–nextYear; from January through June we're still in (or just finished)
 * the season that began the previous fall.
 *
 *   Played Nov 2025 – Mar 2026  ->  season "2025-2026" / "2025-26"
 *   In July 2026                ->  season rolls to "2026-2027" / "2026-27"
 */
const SEASON_START_MONTH = 6; // 0-indexed: 6 = July

function computeSeason(now: Date = new Date()): { startYear: number; endYear: number } {
  const month = now.getMonth();
  const year = now.getFullYear();
  const startYear = month >= SEASON_START_MONTH ? year : year - 1;
  return { startYear, endYear: startYear + 1 };
}

const { startYear, endYear } = computeSeason();

export const CURRENT_SEASON = {
  startYear,
  endYear,
  get seasonDisplay() {
    return `${this.startYear}-${this.endYear}`;
  },
};

/** Full format, e.g. "2025-2026". */
export const CURRENT_SEASON_DISPLAY = `${startYear}-${endYear}`;

/** Short format, e.g. "2025-26". */
export const CURRENT_SEASON_SHORT = `${startYear}-${String(endYear).slice(-2)}`;
